import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import * as io from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  socket;

  constructor() {}

  init(userId: string) {
    const url: string = `/${userId}`;
    const options: any = { path: `/socket.io`, forceNew: false };
    this.socket = io(url, options);
  }

  on(eventName: string, callback: Function) {
    this.socket.on(eventName, callback);
  }

  emit(eventName: string, data?: any, callback?: Function) {
    return this.socket.emit.apply(this.socket, arguments);
  }
}
